import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList } from 'react-native'
import React, { useEffect, useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import * as FileSystem from 'expo-file-system';

const ResourceButtonD = ({ codigo, nombre, ejes,niveles, url, tags, version }) => {


    console.log("----------------CREAR BUTTON DOWNLOAD-----------------")

    const navigation = useNavigation();

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [canDownload, setDownload] = useState(true);
    const [canUpdate, setUpdate] = useState(false);
    const [canDelete, setDeletable] = useState(false);
    //const 

    const Downloadurl = "https://static.sumaysigue.uchile.cl/MatCon/Json/recursos/";
    const jsonDir = FileSystem.documentDirectory  + 'json/';
    const resoucesDir = jsonDir + 'myresources/'



    async function OpenMyJson() {
        const jsonmain = await FileSystem.readAsStringAsync( jsonDir+"main.json",{ encoding: FileSystem.EncodingType.UTF8 } );
        setData( JSON.parse(jsonmain) );
        return jsonmain;
    }

    async function compareResource() {

        data["misrecursos"].forEach(function(element) {
            if (element != undefined)
            {
                if ( (element["codigo"]).toString() == codigo )
                {
                    console.log(element["codigo"]);
                    setDownload(false);
                }
            }
        });
    }


    useEffect(() => {
        OpenMyJson()
    }, []);






    let setresource = (object) => {
        console.log("Elegido curso");
        console.log(Platform.OS)

        var location = "../assets/json/misrecursos/" + codigo + ".json";
        
        navigation.navigate("Situación", { nombre, codigo, location })
    }

    let downloadresource = (object) => {
        console.log("Descargar json:");

        let situname =  JSON.stringify(nombre).toString()

        navigation.navigate("Descarga de situación", {  situname,codigo,url,ejes,niveles,tags,version })
    }

    console.log(ejes);

    return (
        <View>
            <View style={styles.resursoview}>
                <Text>{ nombre["esp"] }</Text>
                <Button
                    title= "Ver Online" 
                    onPress= { setresource }
                    onClick= { setresource }
                /> 
                {canDownload ?  

                    <Button
                        title= "Descargar" 
                        onPress= { downloadresource }
                        onClick= { downloadresource }
                    /> 
                    :
                    <Text/>     
                }
                <Button
                    title= "Actualizar" 
                    onPress= { setUpdate }
                    onClick= { setUpdate }
                /> 
                 <Button
                    title= "Eliminar" 
                    onPress= { downloadresource }
                    onClick= { downloadresource }
                /> 
            </View>
              <Text>{ejes}, {codigo} </Text>
        </View> 
    );
};

const styles = StyleSheet.create({
    resursoview: {
        padding: 6,   
        flexGrow: 1
    },
    buttonDownload: {
        maxWidth: 120,
        backgroundColor: 'red',
    }
});

export default ResourceButtonD